/** The server derives the age; this only formats it. A record that says "34" is
 *  wrong a year later, so the client never computes one. */

export function formatAge(age: number | null | undefined): string {
  if (age === null || age === undefined) return 'Age not recorded'
  if (age === 0) return 'Under 1 year'
  return `${age} ${age === 1 ? 'year' : 'years'}`
}

export function formatSex(sex: string | null | undefined): string {
  switch (sex) {
    case 'female':
      return 'Female'
    case 'male':
      return 'Male'
    case 'other':
      return 'Other'
    default:
      return 'Sex not recorded'
  }
}

/** "42 years · Female" for the identity line, skipping what is unknown. */
export function formatIdentityLine(age: number | null | undefined, sex: string | null | undefined): string {
  const parts: string[] = []
  if (age !== null && age !== undefined) parts.push(formatAge(age))
  if (sex && sex !== 'unknown') parts.push(formatSex(sex))
  return parts.join(' · ')
}
